import React from 'react';
import PropTypes from 'prop-types';
import { PayloadStates } from '@lore/utils';
import MetricLoader from '@/pages/dashboard-year/MetricLoader';
import ComparisonMetric from '@/pages/dashboard-year/ComparisonMetric';
import useEducatorsAffiliatedWithNetworkSite from './useEducatorsAffiliatedWithNetworkSite';

export default function EducatorsAffiliatedWithNetworkSite(props) {
  const { network, schoolStart, schoolEnd, currentTimestamp, titleOnly = false } = props;

  const title = `(den) # active educators affiliated with an [active/claimed by a network] site`;

  const previousUsers = useEducatorsAffiliatedWithNetworkSite(network, {
    end: titleOnly ? undefined : schoolStart
  }, currentTimestamp);

  const newUsers = useEducatorsAffiliatedWithNetworkSite(network, {
    end: schoolEnd
  }, currentTimestamp);

  if (
    previousUsers.state === PayloadStates.FETCHING ||
    newUsers.state === PayloadStates.FETCHING
  ) {
    return (
      <MetricLoader
        name={title}
      />
    );
  }

  return (
    <ComparisonMetric
      name={title}
      value={newUsers.meta.totalCount}
      previousValue={previousUsers.meta.totalCount}
      titleOnly={titleOnly}
    />
  );
}

EducatorsAffiliatedWithNetworkSite.propTypes = {
  network: PropTypes.object.isRequired,
  schoolStart: PropTypes.string.isRequired,
  schoolEnd: PropTypes.string.isRequired,
  currentTimestamp: PropTypes.string.isRequired,
  titleOnly: PropTypes.bool
};
